import * as actionTypes from "../actions/types";

const initialState = {
	projectLikeStatus: null,
	projectLikeStatusLoading: false,
	internshipCountStatus: null,
	internshipCountStatusLoading: false,
	currentYearStat: null,
	currentYearStatLoading: false,
	calendarEvents: [],
	calendarEventsLoading: false,
};
const dashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_DASHBOARD_LIKE_STAT_LOADING:
			return {
				...state,
				projectLikeStatusLoading: action.payload,
			};
		case actionTypes.GET_DASHBOARD_LIKE_STAT:
			return {
				...state,
				projectLikeStatus: action.payload,
			};
		case actionTypes.SET_DASHBOARD_INTERNSHIP_COUNT_LOADING:
			return {
				...state,
				internshipCountStatusLoading: action.payload,
			};
		case actionTypes.GET_DASHBOARD_INTERNSHIP_COUNT:
			return {
				...state,
				internshipCountStatus: action.payload,
			};
		case actionTypes.SET_DASHBOARD_CURRENT_YEAR_STAT_LOADING:
			return {
				...state,
				currentYearStatLoading: action.payload,
			};
		case actionTypes.GET_DASHBOARD_CURRENT_YEAR_STAT:
			return {
				...state,
				currentYearStat: action.payload,
			};
		case actionTypes.SET_DASHBOARD_CALENDAR_EVENTS_LOADING:
			return {
				...state,
				calendarEventsLoading: action.payload,
			};
		case actionTypes.SET_DASHBOARD_CALENDAR_EVENTS:
			return {
				...state,
				calendarEvents: action.payload,
			};
		default:
			return state;
	}
};

export default dashboardReducer;
